var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Farbe des Terminkalenders")]),_c('colorPicker',{attrs:{"value":_vm.color,"callback":_vm.setColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }